import { downloadCsv } from "../utils/csvDownload";

const CSVDownload = (dataToExport, naming = "data.csv") => {
  try {
    downloadCsv(dataToExport, naming);
  } catch (error) {
    console.error("Error downloading CSV:", error);
  }
};

export default CSVDownload;
